<template>
  <b-container fluid>
    <b-row class="mb-2">
      <b-col md="6" style="fonct-size: 0.875rem"
        ><b>Name:</b>{{ customerInfo._clientName }} <b>Mobile:</b
        ><b-button variant="link" @click="dialNum(mobile)">{{ mobile }}</b-button></b-col
      >
      <b-col>
        <b-button variant="info" @click="showDel" size="small" v-if="multiDel"
          >View Linked Accounts</b-button
        >
      </b-col>
    </b-row>
    <b-modal size="xl" ref="modalDel" hide-footer>
      <b-table
        sticky-header="400px"
        small
        style="font-size: 0.75rem"
        :items="delitems"
        striped
        boardered
      ></b-table>
    </b-modal>
    <b-row>
      <b-col md="4" sm="12" class="mt-2">
        <b-form-group
          class="my-2"
          id="grp1"
          label-cols="3"
          label-size="sm"
          label="Call Response"
        >
          <b-select
            size="sm"
            :options="callCodes"
            text-field="formName"
            value-field="_id"
            v-model="selected"
            @change.native="selectForm"
          >
          </b-select>
        </b-form-group>

        <form-generator :schema="schema" v-model="formData"> </form-generator>
        <b-alert
          :show="dismissCountDown"
          dismissible
          :variant="alertVariant"
          @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged"
          >{{ alertText }}</b-alert
        >
        <b-button
          variant="success"
          class="float-right mt-2"
          @click="submitForm"
          size="small"
          >Save</b-button
        >
      </b-col>

      <b-col md="8" sm="12">
        <b-tabs content-class="mt-3">
          <b-tab active>
            <template v-slot:title>
              <span style="font-size: 0.875rem">Genral Info</span>
            </template>
            <b-row>
              <b-col>
                <b-table
                  sticky-header="400px"
                  small
                  style="font-size: 0.75rem"
                  :items="items"
                  striped
                  boardered
                ></b-table>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <span style="font-size: 0.875rem">Call History</span>
            </template>
            <b-table
              small
              style="font-size: 0.75rem"
              show-empty
              :items="callHistory"
              striped
              boardered
            ></b-table>
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <span style="font-size: 0.875rem">Alternate Number</span>
            </template>
            <b-row>
              <b-col md="3">
                <i>Alternate Numbers</i>
                <p v-for="num in alternateNumbers" :key="num">{{ num }}</p>
              </b-col>
              <b-col md="2">
                <i>New Numbers</i>
                <p v-for="num in newNumbers" :key="num">{{ num }}</p>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab v-for="i in tabsArray" :key="'dyn-tab-' + i">
            <template v-slot:title>
              <span style="font-size: 0.875rem">{{ tabsNames[i] }}</span>
            </template>
            <b-table
              small
              show-empty
              style="font-size: 0.75rem"
              :items="itemsArray[i]"
              striped
              boardered
            ></b-table>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import FormGenerator from "../components/Generator/FormGenerator";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import apis from "@/apis";
import * as _ from "lodash";

export default {
  name: "CallerView",
  components: { FormGenerator, DatePicker },
  props: ["mobile", "processname", "sip"],
  data() {
    return {
      campaignid: "",
      selected: "",
      delitems: [],
      multiDel: false,
      callResponse: "",
      positiveFlag: true,
      callCodes: [], //Forms created in Database will be mapped here the text field is 'formName' and value field is '_id'
      callHistory: [],
      formData: {},
      schema: [],
      customerInfo: {},
      items: [],
      tabsArray: [],
      tabsNames: [],
      itemsArray: [],
      alternateNumbers: [],
      newNumbers: [],
      tabCounter: 0,
      dismissSecs: 5,
      dismissCountDown: 0,
      alertText: "",
      alertVariant: "success",
      isLoading: false,
      payload: {
        process: "",
        filter: {},
        set: {},
        push: {},
        inc: {},
      },
    };
  },
  methods: {
    dialNum(mobile){
      //alert(mobile);
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    selectForm(evt) {
      let id = evt.target.value;
      let form = _.filter(this.callCodes, { _id: id });
      if (form) {
        this.schema = form[0].formDetails;
        this.callResponse = form[0].callCode;
        this.positiveFlag = form[0].positiveFlag;
        //this.process = form[0].process;
      }
    },

    submitForm(evt) {
      let callDetails = "Num:" + this.mobile;
      callDetails += "||response:" + this.callResponse;

      if (
        Object.keys(this.formData).length != Object.keys(this.schema).length
      ) {
        this.alertText = "Please fill all data";
        this.alertVariant = "warning";
        this.dismissCountDown = 4;
        return;
      } else if (this.callResponse == "") {
        this.alertText = "Please select response";
        this.alertVariant = "warning";
        this.dismissCountDown = 4;
        return;
      }
      for (var input in this.formData) {
        //Check if all the data is entered by the user.
        if (this.formData[input] == "" || this.formData[input] == null) {
          this.dismissCountDown = this.dismissSecs;
          this.alertText = "Please fill all the fields";
          return;
        }
        if (this.formData[input].constructor.toString().indexOf("Array") > -1) {
          //if there is multiselection create string -> Need optimization
          callDetails += "||" + input + ":" + _.join(this.formData[input], ",");
        } else {
          callDetails += "||" + input + ":" + this.formData[input];
        }
      }

      //Generate Match Criteria for save.
      this.payload.filter = {
        _id: this.customerInfo._id,
        priorityNum: this.campaignid, //in backend make priorityHisotry.priorityNum
      };

      //Generate Set Values for record Update.
      //1. Check PositiveResponse
      let pflg = this.customerInfo.positiveFlag;
      let prspns = this.customerInfo.positiveResponse;
      if (pflg != "Positive") {
        prspns = this.callResponse;
        if (this.positiveFlag) {
          pflg = "Positive";
        } else {
          pflg = "Negative";
        }
      }
      this.payload.set = {
        lastCallResponse: this.callResponse,
        lastCallComment: callDetails,
        lastCallCaller: this.sip,
        lastCallSip: this.sip,
        positiveFlag: pflg,
        positiveResponse: prspns,
        "priorityHisotry.$.priorityPending": false,
        priorityPending: false,
        clientDetails: this.formData,
      };

      //Push Call History
      let callLog = {
        callResponse: this.callResponse,
        callFeedBack: callDetails,
        numberCalled: this.mobile,
        SIP: this.sip,
        positiveFlag: this.positiveFlag,
      };
      this.payload.push = {
        callHistory: callLog,
        clientHistory: this.formData,
      };
      this.payload.inc = { callCount: 1 };

      //console.log(this.payload);

      let promise = apis.saveCall(this.payload);
      promise
        .then((response) => {
          if (response.status == 200) {
            this.alertText = "Datasaved Successfully";
            this.dismissCountDown = this.dismissSecs;
            this.alertVariant = "success";
          } else {
            this.alertText = "Error while Saving Data";
            this.dismissCountDown = 5;
            this.alertVariant = "warning";
            console.log(response);
          }
        })
        .catch((err) => {
          console.error(err);
          this.alertText = "Error in Saving Data:" + err;
          this.alertVariant = "danger";
          this.dismissCountDown = this.dismissSecs;
        });
    },
    showDel() {
      if (this.delitems.length == 0) {
        let promise = apis.getMultiDel(
          this.customerInfo._id,
          this.payload.process
        );

        promise
          .then((response) => {
            if (response.status == 200) {
              this.delitems = response.body;
            }
          })
          .catch((error) => {});
      }
      this.$refs["modalDel"].show();
    },
  },
  mounted() {
    this.delitems = [];

    let promise = apis.getClientNew(
      this.mobile,
      this.processname.replaceAll("+", " ")
    );
    promise
      .then((response) => {
        console.log("Response", response);
        if (response.status == 200) {
          this.customerInfo = response.body.client[0];
          this.callHistory = response.body.client[0].callHistory;
          this.callCodes = response.body.form;
          this.payload.process = this.processname.replaceAll("+", " "); //response.body.form[0].formProcess;
          console.log("Process", this.payload.process);
          if (
            response.body.client[0].priorityNum != "" &&
            response.body.client[0].priorityNum.toString() != "0"
          ) {
            //Need to check if priority is pending
            console.log("Priority", response.body.client[0].priorityNum);
            this.campaignid = response.body.client[0].priorityNum.toString();
          }
          //console.log('schema', JSON.stringify(this.schema));
          //console.log('Info', this.customerInfo);
          for (var i in this.customerInfo) {
            //console.log(typeof this.customerInfo[i]);

            if (i == "multi") {
              if (this.customerInfo[i] > 0) {
                this.multiDel = true;
              }
              this.items.push({ name: i, value: this.customerInfo[i] });
            } else if (i == "alternateNumbers") {
              this.alternateNumbers = _.sortedUniq(this.customerInfo[i]);
            } else if (i == "newNum") {
              this.newNumbers = _.sortedUniq(this.customerInfo[i]);
            } else if (
              i != "clientHistory" &&
              i != "callHistory" &&
              i != "linkedRecords"
            ) {
              console.log(this.customerInfo[i]);
              if (
                typeof this.customerInfo[i] === "object" &&
                this.customerInfo[i] != null
              ) {
                if (
                  this.customerInfo[i].constructor
                    .toString()
                    .indexOf("Object") > -1
                ) {
                  this.items.push({
                    name: i,
                    value: this.customerInfo[i]["$numberDecimal"],
                  });
                } else if (
                  this.customerInfo[i].constructor.toString().indexOf("Date") >
                  -1
                ) {
                  this.items.push({ name: i, value: this.customerInfo[i] });
                } else if (
                  this.customerInfo[i].constructor.toString().indexOf("Array") >
                    -1 &&
                  i != ""
                ) {
                  this.tabsArray.push(this.tabCounter++);
                  this.tabsNames.push(i);
                  this.itemsArray.push(this.customerInfo[i]);
                }
              } else {
                console.log(i);
                this.items.push({ name: i, value: this.customerInfo[i] });
              }
            }
          }
        }
      })
      .catch((err) => {
        this.alertText = "Error is GEtting Data:" + err;
        this.alertVariant = "danger";
        this.dismissSecs = 5;
      });
  },
};
</script>